var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tiptap',{ref:"el-tiptap",attrs:{"spellcheck":false,"extensions":_vm.extensions,"placeholder":"请输入 ..."},on:{"onPaste":_vm.handlePaste},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})}
var staticRenderFns = []

export { render, staticRenderFns }